import {
  FETCHING_USER_GROUPS,
  FETCHING_USER_GROUPS_SUCCEEDED,
  FETCHING_USER_GROUPS_FAILED,
} from "constants/actionTypes";

const initState = {
  items: [],
  loading: false,
  pagination: {
    currentPage: -1,
    totalPages: 1,
    recordsPerPage: 20,
    totalRecordsCount: 0,
  },
};

function userGroupsReducer(state = initState, action) {
  switch (action.type) {
    case FETCHING_USER_GROUPS: {
      return Object.assign({}, state, {
        ...state,
        loading: true,
        items: [],
        pagination: {
          currentPage: -1,
          totalPages: 1,
          recordsPerPage: 20,
          totalRecordsCount: 0,
        },
      });
    }
    case FETCHING_USER_GROUPS_SUCCEEDED: {
      var items = state.items;
      var {
        currentPage,
        totalPages,
        recordsPerPage,
        totalRecordsCount,
        records = [],
      } = action.payload;

      if (currentPage !== 0) {
        items = [...state.items, ...records];
      } else {
        items = records;
      }

      return Object.assign({}, state, {
        ...state,
        loading: false,
        items: items,
        pagination: {
          ...state.pagination,
          currentPage,
          totalPages,
          recordsPerPage,
          totalRecordsCount,
        },
      });
    }
    case FETCHING_USER_GROUPS_FAILED: {
      return Object.assign({}, state, {
        ...state,
        loading: false,
        items: [],
        pagination: {
          currentPage: -1,
          totalPages: 1,
          recordsPerPage: 20,
          totalRecordsCount: 0,
        },
      });
    }

    default:
      return state;
  }
}

export { userGroupsReducer };
